<template>
  <div>
    <CommonExpansionPanel :currentPanel="0">
      <template #title-panel> Carga de Emisiones Alianza Betterware </template>

      <v-col cols="12" class="text-end">
        <v-btn
          dark
          color="#00a7e4"
          rounded
          class="mr-2"
          @click="showReglas = true"
        >
          Ver estructura del archivo
        </v-btn>
      </v-col>

      <v-expansion-panel-content>
        <CargaEmisionesAlianzasFilters @archivoEnviado="registrarJob" />
        <hr />
        <CargaEmisionesAlianzasTable ref="tablaProcesos" />
      </v-expansion-panel-content>
    </CommonExpansionPanel>

    <v-dialog v-model="showReglas" max-width="900">
      <v-card>
        <v-card-title class="headline">
          Estructura esperada del archivo CSV
        </v-card-title>

        <v-card-text>
          <h3 class="mb-3">Campos obligatorios</h3>
          <v-simple-table>
            <thead>
              <tr>
                <th>Campo</th>
                <th>Formato</th>
                <th>Descripción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="campo in camposObligatorios" :key="campo.campo">
                <td>{{ campo.campo }}</td>
                <td>{{ campo.formato }}</td>
                <td>{{ campo.descripcion }}</td>
              </tr>
            </tbody>
          </v-simple-table>

          <v-alert type="warning" outlined class="mt-4">
            Todos los campos obligatorios deben tener contenido. Si falta alguno,
            esa fila quedará registrada como error.
          </v-alert>

          <h3 class="mt-6 mb-3">Campos opcionales conocidos</h3>
          <v-simple-table>
            <thead>
              <tr>
                <th>Campo</th>
                <th>Formato</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="campo in camposOpcionales" :key="campo.campo">
                <td>{{ campo.campo }}</td>
                <td>{{ campo.formato }}</td>
              </tr>
            </tbody>
          </v-simple-table>

          <h3 class="mt-6 mb-3">Ejemplo incluyendo campos opcionales</h3>
          <pre class="csv-example">{{ ejemploCSV }}</pre>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            dark
            color="#00a7e4"
            rounded
            class="mr-2"
            @click="showReglas = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CommonExpansionPanel from "@/components/commonComponents/CommonExpansionPanel.vue";
import CargaEmisionesAlianzasFilters from "./CargaEmisionesAlianzasFilters.vue";
import CargaEmisionesAlianzasTable from "./CargaEmisionesAlianzasTable.vue";

export default {
  components: {
    CommonExpansionPanel,
    CargaEmisionesAlianzasFilters,
    CargaEmisionesAlianzasTable,
  },
  data() {
    return {
      showReglas: false,
      camposObligatorios: [
        {
          campo: "alianza_intermx_id",
          formato: "Número entero",
          descripcion: "La alianza. Debe ser la misma en todas las filas.",
        },
        {
          campo: "producto_id",
          formato: "Número entero",
          descripcion: "Debe existir y pertenecer a la alianza.",
        },
        {
          campo: "nombre",
          formato: "Texto",
          descripcion: "Nombre de la persona.",
        },
        {
          campo: "apellido_paterno",
          formato: "Texto",
          descripcion: "Apellido paterno.",
        },
        {
          campo: "apellido_materno",
          formato: "Texto",
          descripcion: "Apellido materno.",
        },
        {
          campo: "fecha_nacimiento",
          formato: "yyyy-MM-dd",
          descripcion: "Fecha de nacimiento.",
        },
        {
          campo: "telefono_contacto",
          formato: "Texto numérico",
          descripcion: "Teléfono de contacto.",
        },
        {
          campo: "num_socio",
          formato: "Número",
          descripcion:
            "Se recibe como texto internamente, pero en el CSV se manejará numérico.",
        },
        {
          campo: "orden_venta",
          formato: "Texto",
          descripcion: "Número o folio de orden.",
        },
        {
          campo: "fecha_factura",
          formato: "yyyy-MM-dd",
          descripcion: "Fecha de facturación.",
        },
        {
          campo: "fecha_inicio",
          formato: "yyyy-MM-dd",
          descripcion: "Inicio de vigencia.",
        },
        {
          campo: "fecha_fin",
          formato: "yyyy-MM-dd",
          descripcion: "Fin de vigencia; no puede ser anterior al inicio.",
        },
      ],
      camposOpcionales: [
        { campo: "correo_contacto", formato: "Correo electrónico" },
        { campo: "curp", formato: "Texto" },
        { campo: "block_status", formato: "Texto" },
        { campo: "type_phone", formato: "Texto" },
      ],
      ejemploCSV:
        "alianza_intermx_id,producto_id,nombre,apellido_paterno,apellido_materno,fecha_nacimiento,telefono_contacto,num_socio,orden_venta,fecha_factura,fecha_inicio,fecha_fin,correo_contacto,curp\n" +
        "1,125,JUAN,PEREZ,LOPEZ,1990-05-18,5512345678,10001,OV-90001,2026-08-21,2026-08-21,2027-08-20,juan@example.com,PELJ900518HDFRPN01",
    };
  },
  methods: {
    registrarJob(job) {
      if (this.$refs.tablaProcesos) {
        this.$refs.tablaProcesos.registrarJob(job);
      }
    },
  },
};
</script>

<style scoped>
.v-expansion-panel {
  border-radius: 20px;
}

.v-expansion-panels {
  z-index: auto !important;
}

.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)
  > .v-expansion-panel--active {
  border-radius: 20px !important;
  background-color: #f7f8fa;
}

.v-expansion-panel-header {
  background-color: #f7f8fa;
  border-radius: 20px !important;
}

.csv-example {
  padding: 16px;
  overflow-x: auto;
  border-radius: 4px;
  background-color: #f5f5f5;
  white-space: pre;
}
</style>
